import { ClipboardList, MessageCircle, QrCode, Store } from "lucide-react";
import { CaixaRegistradoraIcon, MesaIcon, MotoEntregaIcon, TotemIcon } from "@/components/icons/ModulosIcons";

// Onde um cupom pode valer. As chaves são as do servidor (`coupons/base.py`):
// "ChatBot" é o WhatsApp, a conversa da CLEO. Desde 24/10/2026 (pedido do dono)
// Totem e Mesa QR são módulos próprios, separados de Balcão e Mesas.
export const MODULOS_CUPOM = [
  { key: "Cardapio", label: "Cardápio", icon: Store },
  { key: "Delivery", label: "Delivery", icon: MotoEntregaIcon },
  { key: "Balcao", label: "Balcão", icon: CaixaRegistradoraIcon },
  { key: "Totem", label: "Totem", icon: TotemIcon },
  { key: "Mesas", label: "Mesas", icon: MesaIcon },
  { key: "MesaQR", label: "Mesa QR", icon: QrCode },
  { key: "Comandas", label: "Comandas", icon: ClipboardList },
  { key: "ChatBot", label: "WhatsApp", icon: MessageCircle },
];

export const TODOS_OS_MODULOS = MODULOS_CUPOM.map((m) => m.key);

// A lista gravada no cupom (texto JSON ou lista). Sem lista, o cupom vale em
// todos: é como estão os cupons criados antes deste campo.
export function modulosDoCupom(cupom) {
  let bruto = cupom?.modules;
  if (typeof bruto === "string") {
    try { bruto = JSON.parse(bruto); } catch { bruto = null; }
  }
  if (!Array.isArray(bruto)) return [...TODOS_OS_MODULOS];
  const lista = TODOS_OS_MODULOS.filter((m) => bruto.includes(m));
  return lista.length ? lista : [...TODOS_OS_MODULOS];
}

export const valeEmTodos = (modulos) => TODOS_OS_MODULOS.every((m) => (modulos || []).includes(m));

// "Cardápio, WhatsApp" — ou "Todos os módulos" quando não há restrição.
export function rotuloDosModulos(modulos) {
  if (valeEmTodos(modulos)) return "Todos os módulos";
  return MODULOS_CUPOM.filter((m) => (modulos || []).includes(m.key)).map((m) => m.label).join(", ");
}
